<template>
  <div id="app" class="page">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="less">
  @import url("//at.alicdn.com/t/font_1281905_l692fbpxgdk.css");
  @import url("assets/less/common.less");
</style>